import { isNil } from 'lodash-es';
import { navigateAction } from 'fluxible-router';
import ErrorNotifier from '../../services/error-notifier';
import changeNetwork from '../../components/account/state/actions/change-network';
import { getNetwork, getSpotId, setSpotId, setToken } from 'app/scripts/services/app-state';
import store, { updateAppState } from 'state';
import me from '@spotim/fed-resources/resources/me';
import fetchCurrentUser from 'app/scripts/components/account/state/actions/current-user';
import { clearExportV4ApiKeyFromRedux, clearSpotDataFromRedux } from 'state/helpers/syncHelpers';
import logoutAccount from 'app/scripts/actions/account/logout';
import { setIsChanging } from '../../../spot-selector/spotSelectorSlice';
import { dispatch } from 'state/store';
import { fetchSpotModerationData } from '../../../spots/spotsActions';

export default async function (context, payload, done) {
  let { spotId, networkId, currentSpotId = getSpotId() } = payload;

  if (spotId === currentSpotId) {
    return;
  }

  store.dispatch(setIsChanging(true));

  const spots = store.getState().spotSelector.spots;

  const currentSpot = spots.find(spot => spot.id === currentSpotId);
  const nextSpot = spots.find(spot => spot.id === spotId);

  const nextNetworkId = networkId ?? nextSpot.networkId;
  const currentNetworkId = currentSpot?.networkId || getNetwork().id;

  clearSpotDataFromRedux();
  clearExportV4ApiKeyFromRedux();

  setSpotId(spotId);
  store.dispatch(updateAppState({ spotId }));

  try {
    // In case the new spot chosen is from different network we'll have to update
    // the current user data as well as the token and network state
    if (!isNil(currentNetworkId) && !isNil(nextNetworkId) && currentNetworkId !== nextNetworkId) {
      const { body } = await me.fetchNetworkToken(nextNetworkId);
      setToken(body.token);
      store.dispatch(updateAppState({ token: body.token }));

      await store.dispatch(changeNetwork({ networkId: nextNetworkId, spotId }));
    }

    const currentUserData = await store.dispatch(
      fetchCurrentUser({ spotId, networkId: nextNetworkId, originalNetworkId: currentNetworkId })
    );
    store.dispatch(setIsChanging(false));
    if (!currentUserData.registered) {
      context.executeAction(logoutAccount, { spotId });
    } else {
      dispatch(fetchSpotModerationData(spotId));

      await context.executeAction(navigateAction, { url: `/spot/${spotId}/moderation` });
    }
  } catch (reason) {
    console.error(reason);
    setSpotId(spotId);
    store.dispatch({ type: 'SPOTS/CHANGE_SPOT' });
    ErrorNotifier.notifyError('Error in change current spot action');
  }
}
